import React from "react";
import Avatar from "@material-ui/core/Avatar";

import stringToColor from "../../helpers/stringToColor";
import contrastColor from "../../helpers/contrastColor";

// ---------------------------------------------------------------------------
// ContactAvatar — avatar padrão de contatos.
//
// Regra: quando há foto de perfil, ela é exibida normalmente. Quando NÃO há
// foto (ou a foto falha ao carregar), mostramos a inicial do nome sobre um
// fundo colorido derivado do próprio nome/id — a cor do texto (branco/preto)
// é escolhida automaticamente para garantir contraste legível.
//
// A cor de fundo é sempre aplicada; quando existe uma foto válida, a imagem
// cobre o avatar por completo e a cor não aparece. Isso também garante o
// fallback colorido caso a URL da foto expire.
// ---------------------------------------------------------------------------
const ContactAvatar = ({ name, src, style, children, ...rest }) => {
  const label = name ? String(name) : "";
  const initial = label ? label.charAt(0).toUpperCase() : "?";

  const bgColor = stringToColor(label);
  const fgColor = contrastColor(bgColor);

  return (
    <Avatar
      src={src || undefined}
      alt={label}
      style={{ backgroundColor: bgColor, color: fgColor, ...style }}
      {...rest}
    >
      {children || initial}
    </Avatar>
  );
};

export default ContactAvatar;
